import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../axiosInstance';
import { useTranslation } from 'react-i18next';
import DeleteModal from '../../common/DeleteModal';
import DataTableComponent from "../../common/DataTable/PrimeDataTable";


const SubFormList = ({persona}) => {
  const [resp] = useState('');
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState({ open: false, record: null });
  const [paginationParams, setPaginationParams] = useState({
      limit: 10,
      offset: 0,
      sortField: "createdAt",
      sortOrder: -1
    });
  const navigate = useNavigate();

  useEffect(() => {
    fetchSubForms();
  }, [paginationParams]);

  const fetchSubForms = async () => {
      const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/subforms`, { withCredentials: true })
      .catch((err) => {
          console.log(err);
      });
      
      setData(response?.data);
  };

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder
    }));
  };

  const columns = [
      { field: "id", header: "ID", sortable: true },
      { field: "name", header: t("name"), sortable: true, filter: true },
      // { field: "published", header: t("published"), sortable: true, filter: true, body: (rowData) => rowData.published === 1 ? <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#198754" }} /> : <FontAwesomeIcon icon={faCircleXmark} style={{ color: "#ff0000" }} /> },
      { field: "createdBy", header: t("createdBy"), sortable: true, filter: true, body: (rowData) => rowData.User?.username },
    { field: "createdAt", header: t("createdAt"), sortable: true, filter: true, body: (rowData) => new Date(rowData.createdAt).toLocaleString('en-GB') },
  ];

  const actions = [
    { text: "View", color: "primary", onClick: (row) => navigate(`/${persona}/subforms/details/${row.id}`) },
    { text: t("edit"), color: "secondary", onClick: (row) => navigate(`/${persona}/subforms/edit/${row.id}`) },
    // { text: "Delete", onClick: (row) => setConfirmDeleteModal({ open: true, record: row }), color: "primary", status: 'danger' },
  ];
    
    return (
      <div>
        {resp && <p>{resp}</p>}
        
          <DataTableComponent
          data={data}
          columns={columns}
          actions={actions}
          totalRecords={data?.length}
          enableCreate={true}
          paginationParams={paginationParams}
          onDataTableEvent={onDataTableEvent}
          enablePagination={true} // Enable pagination
          enableLazyLoading={false} // Enable lazy loading
          // enableSelection= {true}
          // selection={selectedRows}
          // onSelectionChange={(e) => setSelectedRows(e.value)}
          // selectionMode="multiple"
          />

          {confirmDeleteModal && (
            <DeleteModal
              sentData={confirmDeleteModal.record}
              onEvent={setConfirmDeleteModal}
              onConfirm={fetchSubForms}
              apiPath="subforms"
              axios={axiosInstance}
              columnName="name"
            />
          )}
        
      </div>
  );
};

export default SubFormList;